import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteFactorRes } from "./helper";

const deleteFactor = async (id: number) =>
  axios.delete(Routes.DELETE_FACTOR + "/" + id);

export const useDeleteFactor = () =>
  useMutation({
    mutationKey: [Keys.DELETE_FACTOR_MUT],
    mutationFn: deleteFactor,
    onSuccess: (res) => {
      onDeleteFactorRes(res);
      return res;
    },
  });
